<template>
   <div>
      <div class="sous-titre">Récoltes 2019</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <bar-chart
            :height="300"
            ref="recoltes"
            :chart-data="graphRecoltes.chartData"
            :options="graphRecoltes.options"
         ></bar-chart>
      </div>
      <div class="sous-titre" style="margin-top:30px">Meilleures ruches 2019</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <bar-chart
            :height="300"
            ref="topRuches"
            :chart-data="graphTopRuches.chartData"
            :options="graphTopRuches.options"
         ></bar-chart>
      </div>
   </div>
</template>

<script>
   import axios from "axios";
   import { BeatLoader } from "@saeris/vue-spinners";
   import BarChart from "@/views/charts/BarChart";
   export default {
      components: {
         BeatLoader,
         BarChart
      },
      data() {
         return {
            annee: new Date().getFullYear(),
            loading: true,
            graphRecoltes: {
               chartData: {
                  labels: [],
                  datasets: []
               },
               options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: {
                     display: false
                  },
                  scales: {
                     xAxes: [
                        {
                           gridLines: {
                              color: "rgba(0, 0, 0, 0.05)"
                           }
                        }
                     ],
                     yAxes: [
                        {
                           ticks: {
                              suggestedMin: 0,
                              suggestedMax: 5
                           },
                           gridLines: {
                              color: "rgba(0, 0, 0, 0.05)"
                           }
                        }
                     ]
                  }
               }
            },
            graphTopRuches: {
               chartData: {
                  labels: [],
                  datasets: []
               },
               options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  legend: {
                     display: false
                  },
                  scales: {
                     xAxes: [
                        {
                           gridLines: {
                              color: "rgba(0, 0, 0, 0.05)"
                           }
                        }
                     ],
                     yAxes: [
                        {
                           ticks: {
                              suggestedMin: 0,
                              suggestedMax: 5
                           },
                           gridLines: {
                              color: "rgba(0, 0, 0, 0.05)"
                           }
                        }
                     ]
                  }
               }
            }
         };
      },
      mounted() {
         this.$store.commit("setTitre", "Statistiques");
         this.getStats();
      },
      methods: {
         async getStats() {
            this.loading = true;
            let res = await axios.get("/stats/" + this.annee);
            // graph récoltes
            let quantites = [];
            let noms = [];
            res.data.recoltes.forEach(recolte => {
               quantites.push(recolte.quantite);
               noms.push(recolte.nom);
            });
            this.initGraphRecoltes(quantites, noms);
            // graph top ruches
            let totaux = [];
            let noms_ruches = [];
            res.data.top.forEach(ruche => {
               totaux.push(ruche.quantite);
               noms_ruches.push(ruche.nom);
            });
            this.initGraphTopRuches(totaux, noms_ruches);

            // fin de chargement
            this.loading = false;
         },
         initGraphRecoltes(quantites, noms) {
            let chartData = {
               datasets: [
                  {
                     label: "Récolte (KG)",
                     data: quantites, // array
                     backgroundColor: [
                        "rgba(165, 0, 255, 1)",
                        "rgba(255, 159, 64, 1)",
                        "rgba(135, 254, 205, 1)",
                        "rgba(165, 244, 255, 1)",
                        "rgba(125, 0, 245, 1)",
                        "rgba(225, 109, 64, 1)"
                     ]
                  }
               ],
               labels: noms // array
            };

            this.graphRecoltes.chartData = chartData;
         },
         initGraphTopRuches(quantites, noms) {
            let chartData = {
               datasets: [
                  {
                     label: "Récolte total (KG)",
                     data: quantites, // array
                     backgroundColor: [
                        "rgba(165, 0, 255, 1)",
                        "rgba(255, 159, 64, 1)",
                        "rgba(165, 244, 255, 1)",
                        "rgba(125, 0, 245, 1)",
                        "rgba(225, 109, 64, 1)",
                        "rgba(135, 254, 205, 1)"
                     ]
                  }
               ],
               labels: noms // array
            };

            this.graphTopRuches.chartData = chartData;
         }
      }
   };
</script>
